import Vue from 'vue'
import Router from 'vue-router'

import homeData from '@/views/homeData'
import home from '@/views/home'
import login from '@/views/login';
import mains from '@/views/mains.vue'
// 基础资料-幼儿园管理-学校信息
import multimediAdd from '@/views/multimediaManagement/multimediAdd'
Vue.use(Router)

export default new Router({
    // mode:'history',
    routes: [{
            path: '/home',
            redirect: '/home',
            name: 'mains',
            component: mains,
            meta: {
                // title: '首页',
                requireAuth: true
            },
            children: [{
                    path: '/home',
                    name: 'home',
                    component: () => import('@/views/home'),
                    meta: {
                        requireAuth: true,
                        title: '首页'
                    }
                },
                {
                    path: '/msmxSSO',
                    name: 'msmxSSO',
                    component: () => import('@/views/msmxSSO'),
                    meta: {
                        requireAuth: true,
                        title: '名师名校'
                    }
                },
                {
                    path: '/homeData',
                    name: 'homeData',
                    component: homeData,
                    meta: {
                        requireAuth: true,
                        title: '数据看板'
                    }
                },
                //基本信息
                {
                    path: '/gradeManage',
                    name: 'gradeManage',
                    component: () => import('@/views/baseInfo/gradeManage'),
                    meta: {
                        requireAuth: true,
                        title: '年级管理'
                    }
                },
                {
                    path: '/classManage',
                    name: 'classManage',
                    component: () => import('@/views/baseInfo/classManage'),
                    meta: {
                        requireAuth: true,
                        title: '班级管理'
                    }
                },
                {
                    path: '/userManage',
                    name: 'userManage',
                    component: () => import('@/views/baseInfo/userManage'),
                    meta: {
                        requireAuth: true,
                        title: '用户管理'
                    }
                },
                {
                    path: '/departmentSchool',
                    name: 'departmentSchool',
                    component: () => import('@/views/baseInfo/departmentSchool'),
                    meta: {
                        requireAuth: true,
                        title: '部门管理(校内)'
                    }
                },
                {
                    path: '/departmentSys',
                    name: 'departmentSys',
                    component: () => import('@/views/baseInfo/departmentSys'),
                    meta: {
                        requireAuth: true,
                        title: '部门管理(系统)'
                    }
                },
                {
                    path: '/schoolRegion',
                    name: 'schoolRegion',
                    component: () => import('@/views/baseInfo/schoolRegion'),
                    meta: {
                        requireAuth: true,
                        title: '校区管理'
                    }
                },
                {
                    path: '/courseManage',
                    name: 'courseManage',
                    component: () => import('@/views/baseInfo/courseManage'),
                    meta: {
                        requireAuth: true,
                        title: '课程管理'
                    }
                },
                {
                    path: '/schoolSetting',
                    name: 'schoolSetting',
                    component: () => import('@/views/baseInfo/schoolSetting'),
                    meta: {
                        requireAuth: true,
                        title: '学段年级配置'
                    }
                },
                {
                    path: '/subjectSetting',
                    name: 'subjectSetting',
                    component: () => import('@/views/baseInfo/subjectSetting'),
                    meta: {
                        requireAuth: true,
                        title: '科目配置'
                    }
                },
                //系统设置
                {
                    path: '/resourceManagement',
                    name: 'resourceManagement',
                    component: () => import('@/views/systemSettings/resourceManagement'),
                    meta: {
                        requireAuth: true,
                        title: '资源管理'
                    }
                },
                {
                    path: '/roleManagementSys',
                    name: 'roleManagementSys',
                    component: () => import('@/views/systemSettings/roleManagement'),
                    meta: {
                        requireAuth: true,
                        title: '角色管理(系统)'
                    }
                },
                {
                    path: '/roleManagement',
                    name: 'roleManagement',
                    component: () => import('@/views/systemSettings/roleManagement'),
                    meta: {
                        requireAuth: true,
                        title: '角色管理(校级)'
                    }
                },
                {
                    path: '/cacheManagement',
                    name: 'cacheManagement',
                    component: () => import('@/views/systemSettings/cacheManagement'),
                    meta: {
                        requireAuth: true,
                        title: '缓存管理'
                    }
                },
                {
                    path: '/regionalManagement',
                    name: 'regionalManagement',
                    component: () => import('@/views/systemSettings/regionalManagement'),
                    meta: {
                        requireAuth: true,
                        title: '区域管理'
                    }
                },
                {
                    path: '/dataDictionary',
                    name: 'dataDictionary',
                    component: () => import('@/views/systemSettings/dataDictionary'),
                    meta: {
                        requireAuth: true,
                        title: '数据字典'
                    }
                },
                {
                    path: '/configurationManagement',
                    name: 'configurationManagement',
                    component: () => import('@/views/systemSettings/configurationManagement'),
                    meta: {
                        requireAuth: true,
                        title: '运行参数'
                    }
                },
                {
                    path: '/expansionModule',
                    name: 'expansionModule',
                    component: () => import('@/views/systemSettings/expansionModule'),
                    meta: {
                        requireAuth: true,
                        title: '扩展模块'
                    }
                },
                {
                    path: '/batchProcessing',
                    name: 'batchProcessing',
                    component: () => import('@/views/systemSettings/batchProcessing'),
                    meta: {
                        requireAuth: true,
                        title: '批量处理'
                    }
                },
                {
                    path: '/resourceOrgManagement',
                    name: 'resourceOrgManagement',
                    component: () => import('@/views/systemSettings/resourceOrgManagement'),
                    meta: {
                        requireAuth: true,
                        title: '机构资源'
                    }
                },
                {
                    path: '/roleOrgManagement',
                    name: 'roleOrgManagement',
                    component: () => import('@/views/systemSettings/roleOrgManagement'),
                    meta: {
                        requireAuth: true,
                        title: '机构角色'
                    }
                },
                {
                    path: '/locationManagement',
                    name: 'locationManagement',
                    component: () => import('@/views/systemSettings/locationManagement'),
                    meta: {
                        requireAuth: true,
                        title: '设备位置管理'
                    }
                },
                //日志查询
                {
                    path: '/loginLog',
                    name: 'loginLog',
                    component: () => import('@/views/journalSearch/loginLog'),
                    meta: {
                        requireAuth: true,
                        title: '登录日志'
                    }
                },
                {
                    path: '/operationLog',
                    name: 'operationLog',
                    component: () => import('@/views/journalSearch/operationLog'),
                    meta: {
                        requireAuth: true,
                        title: '操作日志'
                    }
                },
                //账号管理

                {
                    path: '/adminAccount',
                    name: 'adminAccount',
                    component: () => import('@/views/accountManagement/adminAccount'),
                    meta: {
                        requireAuth: true,
                        title: '系统账号'
                    }
                },
                {
                    path: '/cityAccount',
                    name: 'cityAccount',
                    component: () => import('@/views/accountManagement/cityAccount'),
                    meta: {
                        requireAuth: true,
                        title: '市级账号'
                    }
                },
                {
                    path: '/platManage',
                    name: 'platManage',
                    component: () => import('@/views/accountManagement/platManage'),
                    meta: {
                        requireAuth: true,
                        title: '管理员账号'
                    }
                },
                {
                    path: '/areaAccount',
                    name: 'areaAccount',
                    component: () => import('@/views/accountManagement/areaAccount'),
                    meta: {
                        requireAuth: true,
                        title: '区级账号'
                    }
                },
                {
                    path: '/schoolAccount',
                    name: 'schoolAccount',
                    component: () => import('@/views/accountManagement/schoolAccount'),
                    meta: {
                        requireAuth: true,
                        title: '学校账号'
                    }
                },
                {
                    path: '/schoolManage',
                    name: 'schoolManage',
                    component: () => import('@/views/accountManagement/schoolManage'),
                    meta: {
                        requireAuth: true,
                        title: '学校管理员'
                    }
                },
                {
                    path: '/userList',
                    name: 'userList',
                    component: () => import('@/views/systemSettings/userList'),
                    meta: {
                        requireAuth: true,
                        title: '用户列表'
                    }
                },
                {
                    path: '/multimediaManagement',
                    name: 'multimediaManagement',
                    component: () => import('@/views/multimediaManagement/multimediaManagement'),
                    meta: {
                        requireAuth: true,
                        title: '多媒体管理'
                    }
                },
                {
                    path: '/multimediAdd', //基础资料-幼儿园管理-学校信息
                    name: 'multimediAdd',
                    component: multimediAdd,
                    meta: {
                        requireAuth: true,
                        title: '多媒体播放'
                    },
                },
                // 新增-演练管理
                {
                    path: '/drillManagement',
                    name: 'drillManagement',
                    component: () => import('@/views/drillManagement/drillManagement'),
                    meta: {
                        requireAuth: true,
                        title: '演练管理'
                    }
                },
                //演练分配
                {
                    path: '/drillManAdd',
                    name: 'drillManAdd',
                    component: () => import('@/views/drillManagement/drillManAdd'),
                    meta: {
                        requireAuth: true,
                        title: '演练分配'
                    }
                },
                //新增铃声配置
                {
                    path: '/ringtoneConfigurationMusic',
                    name: 'ringtoneConfigurationMusic',
                    component: () => import('@/views/drillManagement/component/ringtoneConfigurationMusic'),
                    meta: {
                        requireAuth: true,
                        title: '新增铃声配置'
                    }
                },
                {
                    path: '/ringtoneConfiguration',
                    name: 'ringtoneConfiguration',
                    component: () => import('@/views/drillManagement/component/ringtoneConfiguration'),
                    meta: {
                        requireAuth: true,
                        title: '铃声配置'
                    }
                },
                //新增班牌配置
                {
                    path: '/deckArrangement',
                    name: 'deckArrangement',
                    component: () => import('@/views/drillManagement/component/deckArrangement'),
                    meta: {
                        requireAuth: true,
                        title: '班牌配置'
                    }
                },
                {
                    path: '/deckArrangementAdd',
                    name: 'deckArrangementAdd',
                    component: () => import('@/views/drillManagement/component/deckArrangementAdd'),
                    meta: {
                        requireAuth: true,
                        title: '新增班牌配置'
                    }
                },
                //新增屏幕配置
                {
                    path: '/screenConfiguration',
                    name: 'screenConfiguration',
                    component: () => import('@/views/drillManagement/component/screenConfiguration'),
                    meta: {
                        requireAuth: true,
                        title: '屏幕配置'
                    }
                },
                {
                    path: '/screenConfigurationAdd',
                    name: 'screenConfigurationAdd',
                    component: () => import('@/views/drillManagement/component/screenConfigurationAdd'),
                    meta: {
                        requireAuth: true,
                        title: '新增屏幕配置'
                    }
                },
                //新增预警灯配置
                {
                    path: '/earlyWarningLightAdd',
                    name: 'earlyWarningLightAdd',
                    component: () => import('@/views/drillManagement/component/earlyWarningLightAdd'),
                    meta: {
                        requireAuth: true,
                        title: '新增预警灯配置'
                    }
                },
                {
                    path: '/equipmentManageSys',
                    name: 'equipmentManageSys',
                    component: () => import('@/views/equipmentManagement/equipmentManageSys'),
                    meta: {
                        requireAuth: true,
                        title: '设备管理(系统)'
                    }
                },
                {
                    path: '/equipmentManagement',
                    name: 'equipmentManagement',
                    component: () => import('@/views/equipmentManagement/equipmentManagement'),
                    meta: {
                        requireAuth: true,
                        title: '设备管理'
                    }
                },
                {
                    path: '/earlyWarning',
                    name: 'earlyWarning',
                    component: () => import('@/views/campusWarning/earlyWarning'),
                    meta: {
                        requireAuth: true,
                        title: '安全预警'
                    }
                },
                {
                    path: '/materialCenter',
                    name: 'materialCenter',
                    component: () => import('@/views/materialCenter/materialCenter'),
                    meta: {
                        requireAuth: true,
                        title: '素材中心'
                    }
                },
                {
                    path: '/temporaryRingtone',
                    name: 'temporaryRingtone',
                    component: () => import('@/views/temporaryRingtone/temporaryRingtone'),
                    meta: {
                        requireAuth: true,
                        title: '临时铃声'
                    }
                },
                {
                    path: '/drillResult',
                    name: 'drillResult',
                    component: () => import('@/views/drillResult/drillResult'),
                    meta: {
                        requireAuth: true,
                        title: '演练结果'
                    }
                },
                {
                    path: '/equipmentSwitch',
                    name: 'equipmentSwitch',
                    component: () => import('@/views/equipmentSwitch/equipmentSwitch'),
                    meta: {
                        requireAuth: true,
                        title: '设备开关'
                    }
                },
                {
                    path: '/warningProcessing',
                    name: 'warningProcessing',
                    component: () => import('@/views/campusWarning/warningProcessing'),
                    meta: {
                        requireAuth: true,
                        title: '病假预警处理'
                    }
                },
                {
                    path: '/teacherInformation',
                    name: 'teacherInformation',
                    component: () => import('@/views/teacherManagement/teacherInformation'),
                    meta: {
                        requireAuth: true,
                        title: '教师信息'
                    }
                },
                {
                    path: '/portrait',
                    name: 'portrait',
                    component: () => import('@/views/teacherManagement/components/portrait'),
                    meta: {
                        requireAuth: true,
                        title: '教师画像'
                    }
                },
                {
                    path: '/subjectScoreStatistics',
                    name: 'subjectScoreStatistics',
                    component: () => import('@/views/teacherManagement/subjectScoreStatistics'),
                    meta: {
                        requireAuth: true,
                        title: '学科成绩统计'
                    }
                },
                {
                    path: '/performanceStatistics',
                    name: 'performanceStatistics',
                    component: () => import('@/views/teacherManagement/performanceStatistics'),
                    meta: {
                        requireAuth: true,
                        title: '奖励性绩效统计'
                    }
                },
                // 人员管理模块-学生管理
                {
                    path: '/studentManagement',
                    name: 'studentManagement',
                    component: () => import('@/views/studentManagement/studentManagement'),
                    meta: {
                        requireAuth: true,
                        title: '学生管理'
                    }
                },
                // 人员管理模块-家长管理
                {
                    path: '/parentalManage',
                    name: 'parentalManage',
                    component: () => import('@/views/studentManagement/parentalManage'),
                    meta: {
                        requireAuth: true,
                        title: '家长管理'
                    }
                },
                // 人员管理模块-家长使用日志
                {
                    path: '/parentalUsageLogs',
                    name: 'parentalUsageLogs',
                    component: () => import('@/views/studentManagement/parentalUsageLogs'),
                    meta: {
                        requireAuth: true,
                        title: '家长使用日志'
                    }
                },

                // ----------------------------
                {
                    path: '/archivesManagement',
                    name: 'archivesManagement',
                    component: () => import('@/views/archivesManagement/archivesManagement'),
                    meta: {
                        requireAuth: true,
                        title: '在校档案管理'
                    }
                },
                {
                    path: '/viewFile',
                    name: 'viewFile',
                    component: () => import('@/views/archivesManagement/viewFile'),
                    meta: {
                        requireAuth: true,
                        title: '查看档案'
                    }
                },
                {
                    path: '/schoolPerformance',
                    name: 'schoolPerformance',
                    component: () => import('@/views/schoolPerformance/schoolPerformance'),
                    meta: {
                        requireAuth: true,
                        title: '学生在校表现'
                    }
                },
                {
                    path: '/studentFile',
                    name: 'studentFile',
                    component: () => import('@/views/schoolPerformance/studentFile'),
                    meta: {
                        requireAuth: true,
                        title: '学生档案'
                    }
                },
                {
                    path: '/payManagement',
                    name: 'payManagement',
                    component: () => import('@/views/payManagement/payManagement'),
                    meta: {
                        requireAuth: true,
                        title: '缴费管理（班主任）'
                    }
                },
                {
                    path: '/paymentSetting',
                    name: 'paymentSetting',
                    component: () => import('@/views/payManagement/paymentSetting'),
                    meta: {
                        requireAuth: true,
                        title: '缴费管理（领导）'
                    }
                },
                {
                    path: '/psychologicalCounselingLeader',
                    name: 'psychologicalCounselingLeader',
                    component: () => import('@/views/psychologicalCounseling/psychologicalCounselingLeader'),
                    meta: {
                        requireAuth: true,
                        title: '心理咨询管理(领导)'
                    }
                },
                {
                    path: '/studentCardWarn',
                    name: 'studentCardWarn',
                    component: () => import('@/views/campusWarning/studentCardWarn'),
                    meta: {
                        requireAuth: true,
                        title: '处置报警'
                    }
                },
                {
                    path: '/audioWarning',
                    name: 'audioWarning',
                    component: () => import('@/views/campusWarning/audioWarning'),
                    meta: {
                        requireAuth: true,
                        title: '语音预警'
                    }
                },
                {
                    path: '/reportManagement',
                    name: 'reportManagement',
                    component: () => import('@/views/studentsReport/reportManagement'),
                    meta: {
                        requireAuth: true,
                        title: '素质报告书管理(班主任)'
                    }
                },
                {
                    path: '/reportSetting',
                    name: 'reportSetting',
                    component: () => import('@/views/studentsReport/reportSetting'),
                    meta: {
                        requireAuth: true,
                        title: '素质报告书管理(领导)'
                    }
                },
                {
                    path: '/psychological',
                    name: 'psychological',
                    component: () => import('@/views/psychologicalCounseling/psychological'),
                    meta: {
                        requireAuth: true,
                        title: '心理咨询管理（心理老师）'
                    }
                },
                {
                    path: '/classCardVersion',
                    name: 'classCardVersion',
                    component: () => import('@/views/classCardVersion/list'),
                    meta: {
                        requireAuth: false,
                        title: '班牌版本管理'
                    }
                },
                {
                    path: '/equipmentMap',
                    name: 'equipmentMap',
                    component: () => import('@/views/equipmentMap/equipmentMap'),
                    meta: {
                        requireAuth: false,
                        title: '设备地图'
                    }
                },
                {
                    path: '/assginHomeworkL',
                    name: 'assginHomeworkL',
                    component: () => import('@/views/homework/assginHomeworkL'),
                    meta: {
                        requireAuth: true,
                        title: '布置作业(校领导)'
                    }
                },
                {
                    path: '/assginHomeworkT',
                    name: 'assginHomeworkT',
                    component: () => import('@/views/homework/assginHomeworkT'),
                    meta: {
                        requireAuth: true,
                        title: '布置作业(教师)'
                    }
                },
                {
                    path: '/examScoreL',
                    name: 'examScoreL',
                    component: () => import('@/views/exam/examScoreL'),
                    meta: {
                        requireAuth: true,
                        title: '考试成绩(领导)'
                    }
                },
                {
                    path: '/examScoreT',
                    name: 'examScoreT',
                    component: () => import('@/views/exam/examScoreT'),
                    meta: {
                        requireAuth: true,
                        title: '考试成绩(班主任)'
                    }
                },
                {
                    path: '/classTimetableL',
                    name: 'classTimetableL',
                    component: () => import('@/views/timetable/classTimetableL'),
                    meta: {
                        requireAuth: true,
                        title: '班级课表(校领导)'
                    }
                },
                {
                    path: '/classTimetableT',
                    name: 'classTimetableT',
                    component: () => import('@/views/timetable/classTimetableT'),
                    meta: {
                        requireAuth: true,
                        title: '班级课表(班主任)'
                    }
                },
                {
                    path: '/noticeManagement',
                    name: 'noticeManagement',
                    component: () => import('@/views/notice/noticeManagement'),
                    meta: {
                        requireAuth: true,
                        title: '通知公告(班主任)'
                    }
                },
                {
                    path: '/noticeSetting',
                    name: 'noticeSetting',
                    component: () => import('@/views/notice/noticeSetting'),
                    meta: {
                        requireAuth: true,
                        title: '通知公告(领导)'
                    }
                },
                {
                    path: '/campusActivities',
                    name: 'campusActivities',
                    component: () => import('@/views/campus/campusActivities'),
                    meta: {
                        requireAuth: true,
                        title: '校园活动'
                    }
                },
                {
                    path: '/lostAndFound',
                    name: 'lostAndFound',
                    component: () => import('@/views/lostAndFound/lostAndFound'),
                    meta: {
                        requireAuth: true,
                        title: '失物招领'
                    }
                },
                {
                    path: '/homework',
                    name: 'homework',
                    component: () => import('@/views/afterClassServices/homework'),
                    meta: {
                        requireAuth: true,
                        title: '作业布置'
                    }
                },
                {
                    path: '/serveStudent',
                    name: 'serveStudent',
                    component: () => import('@/views/afterClassServices/serveStudent'),
                    meta: {
                        requireAuth: true,
                        title: '服务学生'
                    }
                },
                {
                    path: '/weekMenu',
                    name: 'weekMenu',
                    component: () => import('@/views/afterClassServices/weekMenu'),
                    meta: {
                        requireAuth: false,
                        title: '每周菜单'
                    }
                },
                {
                    path: '/standingBook',
                    name: 'standingBook',
                    component: () => import('@/views/afterClassServices/standingBook'),
                    meta: {
                        requireAuth: false,
                        title: '陪餐台账'
                    }
                },
                {
                    path: '/summaryList',
                    name: 'summaryList',
                    component: () => import('@/views/school/summaryList'),
                    meta: {
                        requireAuth: true,
                        title: '工作总结'
                    }
                },
                {
                    path: '/studentLeave',
                    name: 'studentLeave',
                    component: () => import('@/views/school/studentLeave'),
                    meta: {
                        requireAuth: true,
                        title: '学生请假'
                    }
                },
                {
                    path: '/teacherLeave',
                    name: 'teacherLeave',
                    component: () => import('@/views/school/teacherLeave'),
                    meta: {
                        requireAuth: true,
                        title: '教师请假'
                    }
                },
                {
                    path: '/groupSetting',
                    name: 'groupSetting',
                    component: () => import('@/views/school/groupSetting'),
                    meta: {
                        requireAuth: true,
                        title: '分组配置'
                    }
                },
                {
                    path: '/classLog',
                    name: 'classLog',
                    component: () => import('@/views/school/classLog'),
                    meta: {
                        requireAuth: true,
                        title: '班务日志信息'
                    }
                },
                {
                    path: '/teacherWork',
                    name: 'teacherWork',
                    component: () => import('@/views/school/teacherWork'),
                    meta: {
                        requireAuth: true,
                        title: '教师考勤'
                    }
                },
                {
                    path: '/schoolInfo',
                    name: 'schoolInfo',
                    component: () => import('@/views/school/schoolInfo'),
                    meta: {
                        requireAuth: true,
                        title: '校务信息'
                    }
                }, {
                    path: '/moralList',
                    name: 'moralList',
                    component: () => import('@/views/school/moralList'),
                    meta: {
                        requireAuth: true,
                        title: '德育常规'
                    }
                }, {
                    path: '/schoolOutLog',
                    name: 'schoolOutLog',
                    component: () => import('@/views/school/schoolOutLog'),
                    meta: {
                        requireAuth: true,
                        title: '刷卡出校日志'
                    }
                },{
                    path: '/ypActivityRecord',
                    name: 'ypActivityRecord',
                    component: () => import('@/views/school/ypActivityRecord'),
                    meta: {
                        requireAuth: true,
                        title: '少先队活动记录'
                    }
                },{
                    path: '/conferenceAttendance',
                    name: 'conferenceAttendance',
                    component: () => import('@/views/school/conferenceAttendance'),
                    meta: {
                        requireAuth: true,
                        title: '会务考勤'
                    }
                },
                // 校级-教职工管理(校级)
                {
                    path: '/manageList',
                    name: 'manageList',
                    component: () => import('@/views/baseInfo/manageList'),
                    meta: {
                        requireAuth: true,
                        title: '教职工管理'
                    }
                },
                {
                    path: '/workPlan',
                    name: 'workPlan',
                    component: () => import('@/views/workPlan/workPlan'),
                    meta: {
                        requireAuth: true,
                        title: '工作计划'
                    }
                },
                //值班巡查
                {
                    path: '/patrolInfo',
                    name: 'patrolInfo',
                    component: () => import('@/views/dutyPatrol/patrolInfo'),
                    meta: {
                        requireAuth: true,
                        title: '巡查信息'
                    }
                },
                {
                    path: '/dailyPatrol',
                    name: 'dailyPatrol',
                    component: () => import('@/views/dutyPatrol/dailyPatrol'),
                    meta: {
                        requireAuth: true,
                        title: '教学巡查'
                    }
                },
                {
                    path: '/eduPatrolRectify',
                    name: 'eduPatrolRectify',
                    component: () => import('@/views/dutyPatrol/eduPatrolRectify'),
                    meta: {
                        requireAuth: true,
                        title: '教学巡查整改'
                    }
                },
                {
                    path: '/safePatrol',
                    name: 'safePatrol',
                    component: () => import('@/views/dutyPatrol/safePatrol'),
                    meta: {
                        requireAuth: true,
                        title: '安全巡查'
                    }
                },
                {
                    path: '/safeHazardManage',
                    name: 'safeHazardManage',
                    component: () => import('@/views/dutyPatrol/safeHazardManage'),
                    meta: {
                        requireAuth: true,
                        title: '安全隐患管理'
                    }
                },
                {
                    path: '/visitorList',
                    name: 'visitorList',
                    component: () => import('@/views/dutyPatrol/visitorList'),
                    meta: {
                        requireAuth: true,
                        title: '来访记录'
                    }
                },
                {
                    path: '/dutySetting',
                    name: 'dutySetting',
                    component: () => import('@/views/dutyPatrol/dutySetting'),
                    meta: {
                        requireAuth: true,
                        title: '值班配置'
                    }
                },
                {
                    path: '/safetyWatch',
                    name: 'safetyWatch',
                    component: () => import('@/views/dutyPatrol/safetyWatch'),
                    meta: {
                        requireAuth: true,
                        title: '安全值班'
                    }
                },
                {
                    path: '/noticeReview',
                    name: 'noticeReview',
                    component: () => import('@/views/contentReview/noticeReview'),
                    meta: {
                        requireAuth: true,
                        title: '通知审核(领导)'
                    }
                },
                {
                    path: '/classAudit',
                    name: 'classAudit',
                    component: () => import('@/views/contentReview/classAudit'),
                    meta: {
                        requireAuth: true,
                        title: '班务审核(领导)'
                    }
                },
                {
                    path: '/homeworkReview',
                    name: 'homeworkReview',
                    component: () => import('@/views/contentReview/homeworkReview'),
                    meta: {
                        requireAuth: true,
                        title: '作业审核(领导)'
                    }
                },
                {
                    path: '/disciplineManagement',
                    name: 'disciplineManagement',
                    component: () => import('@/views/baseInfo/disciplineManagement'),
                    meta: {
                        requireAuth: true,
                        title: '学科管理'
                    }
                },
                {
                    path: '/schoolLevelReview',
                    name: 'schoolLevelReview',
                    component: () => import('@/views/contentReview/schoolLevelReview'),
                    meta: {
                        requireAuth: true,
                        title: '校级公告审核'
                    }
                },
                {
                    path: '/classReview',
                    name: 'classReview',
                    component: () => import('@/views/contentReview/classReview'),
                    meta: {
                        requireAuth: true,
                        title: '班级公告审核'
                    }
                },
                {
                    path: '/curriculumReview',
                    name: 'curriculumReview',
                    component: () => import('@/views/contentReview/curriculumReview'),
                    meta: {
                        requireAuth: true,
                        title: '班级课表审核'
                    }
                },
                {
                    path: '/activityReview',
                    name: 'activityReview',
                    component: () => import('@/views/contentReview/activityReview'),
                    meta: {
                        requireAuth: true,
                        title: '校园活动审核'
                    }
                },
                // 图书借阅-模块
                {
                    path: '/bookStorage',
                    name: 'bookStorage',
                    component: () => import('@/views/book/bookStorage'),
                    meta: {
                        requireAuth: true,
                        title: '图书入库'
                    }
                },
                {
                    path: '/bookClassification',
                    name: 'bookClassification',
                    component: () => import('@/views/book/bookClassification'),
                    meta: {
                        requireAuth: true,
                        title: '图书分类'
                    }
                },
                {
                    path: '/bookManagement',
                    name: 'bookManagement',
                    component: () => import('@/views/book/bookManagement'),
                    meta: {
                        requireAuth: true,
                        title: '图书借阅管理'
                    }
                },
                {
                    path: '/bookLedger',
                    name: 'bookLedger',
                    component: () => import('@/views/book/bookLedger'),
                    meta: {
                        requireAuth: true,
                        title: '图书台账'
                    }
                },
                // 打卡奖励规则页面
                {
                    path: '/bookRules',
                    name: 'bookRules',
                    component: () => import('@/views/book/bookRules'),
                    meta: {
                        requireAuth: true,
                        title: '打卡奖励规则'
                    }
                },
                // 素材二维码模块
                {
                    path: '/qrCodeManagement',
                    name: 'qrCodeManagement',
                    component: () => import('@/views/qrCode/qrCodeManagement'),
                    meta: {
                        requireAuth: true,
                        title: '二维码管理'
                    }
                },
                {
                    path: '/evaluateDiscuss',
                    name: 'evaluateDiscuss',
                    component: () => import('@/views/evaluateDiscuss/evaluateDiscuss'),
                    meta: {
                        requireAuth: true,
                        title: '评课议课'
                    }
                },
                {
                    path: '/listenEvaluationCriteria',
                    name: 'listenEvaluationCriteria',
                    component: () => import('@/views/evaluateDiscuss/listenEvaluationCriteria'),
                    meta: {
                        requireAuth: true,
                        title: '听评课标准'
                    }
                },
                // 社团进校模块
                {
                    path: '/clubManage',
                    name: 'clubManage',
                    component: () => import('@/views/club/clubManage'),
                    meta: {
                        requireAuth: true,
                        title: '社团管理'
                    }
                },
                // 社团进校模块
                {
                    path: '/clubActivity',
                    name: 'clubActivity',
                    component: () => import('@/views/club/clubActivity'),
                    meta: {
                        requireAuth: true,
                        title: '社团活动记录'
                    }
                },
                // 集智备课模块-备课活动页面
                {
                    path: '/activityPreparation',
                    name: 'activityPreparation',
                    component: () => import('@/views/preparation/activityPreparation'),
                    meta: {
                        requireAuth: true,
                        title: '备课活动'
                    }
                },
                // 集智备课模块-备课教案页面
                {
                    path: '/teachingPlan',
                    name: 'teachingPlan',
                    component: () => import('@/views/preparation/teachingPlan'),
                    meta: {
                        requireAuth: true,
                        title: '备课教案'
                    }
                },
                // 教学常规检查页面
                {
                    path: '/inspectionTeaching',
                    name: 'inspectionTeaching',
                    component: () => import('@/views/inspection/inspectionTeaching'),
                    meta: {
                        requireAuth: true,
                        title: '教学常规检查'
                    }
                },
                // 教学常规检查整改
                {
                    path: '/inspectionRectify',
                    name: 'inspectionRectify',
                    component: () => import('@/views/inspection/inspectionRectify'),
                    meta: {
                        requireAuth: true,
                        title: '教学常规检查整改'
                    }
                },

                // 积分商城-积分商品管理
                {
                    path: '/commodityManage',
                    name: 'commodityManage',
                    component: () => import('@/views/pointShop/commodityManage'),
                    meta: {
                        requireAuth: true,
                        title: '积分商品管理'
                    }
                },
                // 积分商城-商品兑换确定
                {
                    path: '/commodityExchange',
                    name: 'commodityExchange',
                    component: () => import('@/views/pointShop/commodityExchange'),
                    meta: {
                        requireAuth: true,
                        title: '商品兑换确定'
                    }
                },
                // 积分商城-积分记录
                {
                    path: '/pointsRecord',
                    name: 'pointsRecord',
                    component: () => import('@/views/pointShop/pointsRecord'),
                    meta: {
                        requireAuth: true,
                        title: '积分记录'
                    }
                },
                // 积分商城-积分卡管理
                {
                    path: '/pointCardManage',
                    name: 'pointCardManage',
                    component: () => import('@/views/pointShop/pointCardManage'),
                    meta: {
                        requireAuth: true,
                        title: '积分卡管理'
                    }
                },
                // 学生画像
                {
                    path: '/studentPortraitT',
                    name: 'studentPortraitT',
                    component: () => import('@/views/studentRadar/studentPortrait'),
                    meta: {
                        requireAuth: true,
                        title: '学生画像(教师)'
                    }
                },
                // 学生画像
                {
                    path: '/studentPortraitL',
                    name: 'studentPortraitL',
                    component: () => import('@/views/studentRadar/studentPortrait'),
                    meta: {
                        requireAuth: true,
                        title: '学生画像(领导)'
                    }
                },
                {
                    path: '/stuPortrait',
                    name: 'stuPortrait',
                    component: () => import('@/views/studentRadar/components/stuPortrait'),
                    meta: {
                        requireAuth: true,
                        title: '学生画像'
                    }
                },
                // 学生指标配置
                {
                    path: '/studentZhibiao',
                    name: 'studentZhibiao',
                    component: () => import('@/views/studentRadar/studentZhibiao'),
                    meta: {
                        requireAuth: true,
                        title: '学生指标配置'
                    }
                },

                // 教师画像
                // 教师画像汇总
                {
                    path: '/radarSummary',
                    name: 'radarSummary',
                    component: () => import('@/views/teacherRadar/radarSummary'),
                    meta: {
                        requireAuth: true,
                        title: '教师画像汇总'
                    }
                },
                // 工作量评分
                {
                    path: '/workLoadManage',
                    name: 'workLoadManage',
                    component: () => import('@/views/teacherRadar/workLoadManage'),
                    meta: {
                        requireAuth: true,
                        title: '工作量评分'
                    }
                },
                // 获奖管理
                {
                    path: '/rawardManage',
                    name: 'rawardManage',
                    component: () => import('@/views/teacherRadar/rawardManage'),
                    meta: {
                        requireAuth: true,
                        title: '获奖管理'
                    }
                },
                // 教师扣分
                {
                    path: '/teacherDemerits',
                    name: 'teacherDemerits',
                    component: () => import('@/views/teacherRadar/teacherDemerits'),
                    meta: {
                        requireAuth: true,
                        title: '教师扣分'
                    }
                },
                {
                    path: '/moduleTourneyList',
                    name: 'moduleTourneyList',
                    component: () => import('@/views/teacherRadar/moduleTourneyList'),
                    meta: {
                        requireAuth: false,
                        title: '开放周活动(领导)'
                    }
                },
                {
                    path: '/tourneyEvaluate',
                    name: 'tourneyEvaluate',
                    component: () => import('@/views/teacherRadar/components/tourneyEvaluate'),
                    meta: {
                        requireAuth: false,
                        title: '开放周活动评价'
                    }
                },
                {
                    path: '/peerEvaluate',
                    name: 'peerEvaluate',
                    component: () => import('@/views/teacherRadar/components/peerEvaluate'),
                    meta: {
                        requireAuth: false,
                        title: '开放周活动互评'
                    }
                },
                {
                    path: '/moduleTourneyTeacher',
                    name: 'moduleTourneyTeacher',
                    component: () => import('@/views/teacherRadar/moduleTourneyTeacher'),
                    meta: {
                        requireAuth: false,
                        title: '开放周活动(教师)'
                    }
                },
                {
                    path: '/teachingResearch',
                    name: 'teachingResearch',
                    component: () => import('@/views/teacherRadar/teachingResearch'),
                    meta: {
                        requireAuth: false,
                        title: '教研活动'
                    }
                },
                {
                    path: '/teacherZhibiao',
                    name: 'teacherZhibiao',
                    component: () => import('@/views/teacherRadar/teacherZhibiao'),
                    meta: {
                        requireAuth: false,
                        title: '教师指标配置'
                    }
                },
                {
                    path: '/templateSetting',
                    name: 'templateSetting',
                    component: () => import('@/views/teacherRadar/templateSetting'),
                    meta: {
                        requireAuth: false,
                        title: '模板配置'
                    }
                },
                {
                    path: '/releaseManage',
                    name: 'releaseManage',
                    component: () => import('@/views/teacherRadar/releaseManage'),
                    meta: {
                        requireAuth: false,
                        title: '发布管理'
                    }
                },
                {
                    path: '/releaseProgress',
                    name: 'releaseProgress',
                    component: () => import('@/views/teacherRadar/components/releaseProgress'),
                    meta: {
                        requireAuth: false,
                        title: '发布管理-进度'
                    }
                },
                {
                    path: '/tchPortrait',
                    name: 'tchPortrait',
                    component: () => import('@/views/teacherRadar/components/tchPortrait'),
                    meta: {
                        requireAuth: false,
                        title: '教师画像'
                    }
                },
                {
                    path: '/attendanceManage',
                    name: 'attendanceManage',
                    component: () => import('@/views/teacherRadar/attendanceManage'),
                    meta: {
                        requireAuth: false,
                        title: '教师考勤评分'
                    }
                },
                {
                    path: '/teacherFilling',
                    name: 'teacherFilling',
                    component: () => import('@/views/teacherRadar/teacherFilling'),
                    meta: {
                        requireAuth: false,
                        title: '教师填报'
                    }
                },
                {
                    path: '/writeQuest',
                    name: 'writeQuest',
                    component: () => import('@/views/teacherRadar/components/writeQuest'),
                    meta: {
                        requireAuth: false,
                        title: '去填报'
                    }
                },

                // 账号管理模块
                // 管理员账号
                {
                    path: '/administrator',
                    name: 'administrator',
                    component: () => import('@/views/account/administrator'),
                    meta: {
                        requireAuth: true,
                        title: '管理员账号'
                    }
                },
                // 市级账号
                {
                    path: '/cityLevel',
                    name: 'cityLevel',
                    component: () => import('@/views/account/cityLevel'),
                    meta: {
                        requireAuth: true,
                        title: '市级账号'
                    }
                },
                // 区级账号
                {
                    path: '/regionLevel',
                    name: 'regionLevel',
                    component: () => import('@/views/account/regionLevel'),
                    meta: {
                        requireAuth: true,
                        title: '区级账号'
                    }
                },
                // 教联体账号
                {
                    path: '/educationLevel',
                    name: 'educationLevel',
                    component: () => import('@/views/account/educationLevel'),
                    meta: {
                        requireAuth: true,
                        title: '教联体账号'
                    }
                },
                // 校级账号
                {
                    path: '/schoolLevel',
                    name: 'schoolLevel',
                    component: () => import('@/views/account/schoolLevel'),
                    meta: {
                        requireAuth: true,
                        title: '校级账号'
                    }
                },

                // 基本信息模块-教联体管理
                {
                    path: '/educationalManage',
                    name: 'educationalManage',
                    component: () => import('@/views/management/educationalManage'),
                    meta: {
                        requireAuth: true,
                        title: '教联体管理'
                    }
                },
                // // 基本信息模块-学校管理
                // {
                //   path: '/schoolManagement',
                //   name: 'schoolManagement',
                //   component: () => import('@/views/management/schoolManagement'),
                //   meta: {
                //     requireAuth: true,
                //     title: '学校管理'
                //   }
                // },
                // 总-学校管理
                {
                    path: '/schoManege',
                    name: 'schoManege',
                    component: () => import('@/views/management/schoManege'),
                    meta: {
                        requireAuth: true,
                        title: '学校管理'
                    }
                },
                // 总-学校科目
                {
                    path: '/schoolSub',
                    name: 'schoolSub',
                    component: () => import('@/views/management/schoolSub'),
                    meta: {
                        requireAuth: true,
                        title: '学校科目'
                    }
                },
                // 总-学生管理
                {
                    path: '/stuManage',
                    name: 'stuManage',
                    component: () => import('@/views/management/stuManage'),
                    meta: {
                        requireAuth: true,
                        title: '学生管理'
                    }
                },
                // 总-教职工管理
                {
                    path: '/staffMange',
                    name: 'staffMange',
                    component: () => import('@/views/management/staffMange'),
                    meta: {
                        requireAuth: true,
                        title: '教职工管理'
                    }
                },

                // 基本信息模块-学校科目
                // {
                //   path: '/schoolSubjects',
                //   name: 'schoolSubjects',
                //   component: () => import('@/views/management/schoolSubjects'),
                //   meta: {
                //     requireAuth: true,
                //     title: '学校科目'
                //   }
                // },
                // // 基本信息模块-教职工管理
                // {
                //   path: '/administrative',
                //   name: 'administrative',
                //   component: () => import('@/views/management/administrative'),
                //   meta: {
                //     requireAuth: true,
                //     title: '教职工管理'
                //   }
                // },
                // // 基本信息模块-学生管理
                // {
                //   path: '/studentManageBasic',
                //   name: 'studentManageBasic',
                //   component: () => import('@/views/management/studentManageBasic'),
                //   meta: {
                //     requireAuth: true,
                //     title: '学生管理'
                //   }
                // },

                // // 教联体模块-学校管理(教联体)
                // {
                //   path: '/manageSchoolEducation',
                //   name: 'manageSchoolEducation',
                //   component: () => import('@/views/education/manageSchoolEducation'),
                //   meta: {
                //     requireAuth: true,
                //     title: '学校管理(教联体)'
                //   }
                // },
                // 教联体模块-学校科目(教联体)
                // {
                //   path: '/schoolSubjectsEducation',
                //   name: 'schoolSubjectsEducation',
                //   component: () => import('@/views/education/schoolSubjectsEducation'),
                //   meta: {
                //     requireAuth: true,
                //     title: '学校科目(教联体)'
                //   }
                // },
                //  // 教联体模块-教职工管理(教联体)
                //  {
                //   path: '/facultyEducatioln',
                //   name: 'facultyEducatioln',
                //   component: () => import('@/views/education/facultyEducatioln'),
                //   meta: {
                //     requireAuth: true,
                //     title: '学校科目(教联体)'
                //   }
                // },
                //  // 教联体模块-学生管理(教联体)
                //  {
                //   path: '/studentEducation',
                //   name: 'studentEducation',
                //   component: () => import('@/views/education/studentEducation'),
                //   meta: {
                //     requireAuth: true,
                //     title: '学生管理(教联体)'
                //   }
                // },

                // 校级端---------------------------------------
                // 科目管理(校级端)
                {
                    path: '/subjectManageSchool',
                    name: 'subjectManageSchool',
                    component: () => import('@/views/management/subjectManageSchool'),
                    meta: {
                        requireAuth: true,
                        title: '科目管理(校级端))'
                    }
                },


                // 单级！！---学校基础配置--------------------------------
                // 学校基础配置-基础配置-总 
                {
                    path: '/basicConfiguration',
                    name: 'basicConfiguration',
                    component: () => import('@/views/schoolBasicOne/basicConfiguration'),
                    meta: {
                        requireAuth: true,
                        title: '基础配置'
                    }
                },
                // 学校基础配置-打卡时间配置 
                {
                    path: '/clockInTime',
                    name: 'clockInTime',
                    component: () => import('@/views/schoolBasicOne/clockInTime'),
                    meta: {
                        requireAuth: true,
                        title: '打卡时间配置'
                    }
                },
                // 学校基础配置-设备位置 
                {
                    path: '/deviceLocation',
                    name: 'deviceLocation',
                    component: () => import('@/views/schoolBasicOne/deviceLocation'),
                    meta: {
                        requireAuth: true,
                        title: '设备位置'
                    }
                },
                // 学校基础配置-值班岗点 
                {
                    path: '/dutyPoint',
                    name: 'dutyPoint',
                    component: () => import('@/views/schoolBasicOne/dutyPoint'),
                    meta: {
                        requireAuth: true,
                        title: '值班岗点'
                    }
                },
                // 学校基础配置-学期年度 
                {
                    path: '/semesterYear',
                    name: 'semesterYear',
                    component: () => import('@/views/schoolBasicOne/semesterYear'),
                    meta: {
                        requireAuth: true,
                        title: '学期年度'
                    }
                },
                // 学校基础配置-学期开始时间 
                {
                    path: '/startTime',
                    name: 'startTime',
                    component: () => import('@/views/schoolBasicOne/startTime'),
                    meta: {
                        requireAuth: true,
                        title: '学期开始时间'
                    }
                },
                // 学校基础配置-巡查类型 
                {
                    path: '/inspectionType',
                    name: 'inspectionType',
                    component: () => import('@/views/schoolBasicOne/inspectionType'),
                    meta: {
                        requireAuth: true,
                        title: '巡查类型'
                    }
                },
                // 学校基础配置-巡查部门 
                {
                    path: '/inspectionDepartment',
                    name: 'inspectionDepartment',
                    component: () => import('@/views/schoolBasicOne/inspectionDepartment'),
                    meta: {
                        requireAuth: true,
                        title: '巡查部门'
                    }
                },
                // 学校基础配置-素质报告书日期 
                {
                    path: '/dateQualityReport',
                    name: 'dateQualityReport',
                    component: () => import('@/views/schoolBasicOne/dateQualityReport'),
                    meta: {
                        requireAuth: true,
                        title: '素质报告书日期'
                    }
                },
                // 学校基础配置-素质报告书学科 
                {
                    path: '/qualityReportSubject',
                    name: 'qualityReportSubject',
                    component: () => import('@/views/schoolBasicOne/qualityReportSubject'),
                    meta: {
                        requireAuth: true,
                        title: '素质报告书学科'
                    }
                },
                // 学校基础配置-素质报告书学科 
                {
                    path: '/planSummaryTime',
                    name: 'planSummaryTime',
                    component: () => import('@/views/schoolBasicOne/planSummaryTime'),
                    meta: {
                        requireAuth: true,
                        title: '素质报告书学科'
                    }
                },
                // 学校基础配置-计划总结部门 
                {
                    path: '/planSummaryDepartment',
                    name: 'planSummaryDepartment',
                    component: () => import('@/views/schoolBasicOne/planSummaryDepartment'),
                    meta: {
                        requireAuth: true,
                        title: '计划总结部门'
                    }
                },
                // 学校基础配置-移动端功能配置 
                {
                    path: '/appManagement',
                    name: 'appManagement',
                    component: () => import('@/views/schoolBasicOne/appManagement'),
                    meta: {
                        requireAuth: true,
                        title: '移动端功能配置'
                    }
                },

                // 多级！！---学校基础配置--------------------------------
                // 学校基础配置-巡查计分
                {
                    path: '/patrolScoring',
                    name: 'patrolScoring',
                    component: () => import('@/views/schoolBasicTwo/patrolScoring'),
                    meta: {
                        requireAuth: true,
                        title: '巡查计分'
                    }
                },
                // 学校基础配置-巡查分类
                {
                    path: '/patrolCate',
                    name: 'patrolCate',
                    component: () => import('@/views/schoolBasicTwo/patrolCate'),
                    meta: {
                        requireAuth: true,
                        title: '巡查分类'
                    }
                },
                // 学校基础配置-综合素质评价
                {
                    path: '/qualityComment',
                    name: 'qualityComment',
                    component: () => import('@/views/schoolBasicTwo/qualityComment'),
                    meta: {
                        requireAuth: true,
                        title: '综合素质评价'
                    }
                },
                // 学校基础配置-服务学生时间段
                {
                    path: '/servestuTime',
                    name: 'servestuTime',
                    component: () => import('@/views/schoolBasicTwo/servestuTime'),
                    meta: {
                        requireAuth: true,
                        title: '服务学生时间段'
                    }
                },
                // 学校基础配置-放学打卡时间段
                {
                    path: '/schoolOutTime',
                    name: 'schoolOutTime',
                    component: () => import('@/views/schoolBasicTwo/schoolOutTime'),
                    meta: {
                        requireAuth: true,
                        title: '放学打卡时间段'
                    }
                },
                // 学校基础配置-生日祝福配置
                {
                    path: '/happyBirthday',
                    name: 'happyBirthday',
                    component: () => import('@/views/schoolBasicTwo/happyBirthday'),
                    meta: {
                        requireAuth: true,
                        title: '生日祝福配置'
                    }
                },
                // 校务信息-工作报表统计
                {
                    path: '/workReportList',
                    name: 'workReportList',
                    component: () => import('@/views/school/workReportList'),
                    meta: {
                        requireAuth: true,
                        title: '工作报表统计'
                    }
                },
                // 设备信息-楼道大屏管理
                {
                    path: '/screenManagement',
                    name: 'screenManagement',
                    component: () => import('@/views/equipmentManagement/screenManagement'),
                    meta: {
                        requireAuth: true,
                        title: '楼道大屏管理'
                    }
                },
                // 人员管理-教师信息档案
                {
                    path: '/teacherArchives',
                    name: 'teacherArchives',
                    component: () => import('@/views/teacherManagement/teacherArchives'),
                    meta: {
                        requireAuth: true,
                        title: '教师信息档案'
                    }
                },
                // 人员管理-教师信息档案
                {
                    path: '/archivesHistory',
                    name: 'archivesHistory',
                    component: () => import('@/views/teacherManagement/components/archivesHistory'),
                    meta: {
                        requireAuth: true,
                        title: '教师信息历史记录'
                    }
                },
            ]
        },
        {
            path: '/dataBoard',
            name: 'dataBoard',
            component: () => import('@/views/dataBoard'),
            meta: {
                requireAuth: false,
                title: '数据看板'
            }
        },
        {
            path: '/teacherBoard',
            name: 'teacherBoard',
            component: () => import('@/views/teacherBoard'),
            meta: {
                requireAuth: false,
                title: '教师看板'
            }
        },
        {
            path: '/studentBoard',
            name: 'studentBoard',
            component: () => import('@/views/studentBoard'),
            meta: {
                requireAuth: false,
                title: '学生看板'
            }
        },
        {
            path: '/board',
            name: 'board',
            component: () => import('@/views/board'),
            meta: {
                requireAuth: false,
                title: '看板汇总'
            }
        },
        {
            path: '/psychologicalCounseling',
            name: 'psychologicalCounseling',
            component: () => import('@/views/psychologicalCounseling/counseling'),
            meta: {
                requireAuth: false,
                title: '心理咨询室'
            }
        },
        {
            path: '/h5_safe',
            name: 'h5_safe',
            component: () => import('@/views/safe/h5_safe'),
            meta: {
                requireAuth: false,
                title: '安全防疫'
            }
        },
        {
            path: '/info',
            name: 'info',
            component: () => import('@/views/safe/info'),
            meta: {
                requireAuth: false,
                title: '安全防疫详情'
            }
        },
        {
            path: '/',
            name: 'login',
            component: login
        },
        {
            path: '/password',
            name: 'password',
            component: () =>
                import('@/views/password')
        },
        {
            path: '/sso',
            name: 'sso',
            component: () => import('@/views/sso')
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js